export default __webpack_public_path__ + "static/media/ic_add.9e1bdab2.svg";